import DocumentLayout from 'global/DocumentLayout';
import GuestNotFound from 'global/NotFound/GuestNotFound';
import Post from 'global/StreamWidget/Post';
import { StreamPostData } from '../../../@types/stream';
import { GuestPostWrapper } from './styled';

interface ArticleLayoutProps {
  post: StreamPostData;
}

const GuestPostDetail = ({ post }: ArticleLayoutProps) => {
  if (!post) {
    return <GuestNotFound />;
  }

  return (
    <DocumentLayout>
      <GuestPostWrapper>
        <Post
          post={post}
          showLatestComment={false}
          hasFollowingActivity={false}
          isSinglePost
          entryPoint="detail"
        />
      </GuestPostWrapper>
    </DocumentLayout>
  );
};

export default GuestPostDetail;
